var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table-pagination',{attrs:{"page":Number(_vm.value) || 1,"total-rows":Number(_vm.totalRows) || 0,"per-page":Number(_vm.perPage) || 20},on:{"change":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }